export default function injectWebCss() {
  if (typeof document === 'undefined') return;

  const style = document.createElement('style');
  style.type = 'text/css';
  style.appendChild(document.createTextNode(`
    /* Reset and base styles */
    *, *::before, *::after {
      box-sizing: border-box;
    }

    html {
      -webkit-text-size-adjust: 100%;
      scroll-behavior: smooth;
    }

    body {
      margin: 0;
      padding: 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      overflow-x: hidden;
    }

    /* Remove webkit appearance from inputs */
    input, textarea, select, button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      font-family: inherit;
    }

    input:focus, textarea:focus, select:focus, button:focus {
      outline: none;
    }

    /* Custom scrollbar */
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #a1a1a1;
    }

    /* Hide scrollbar for specific elements */
    .hide-scrollbar::-webkit-scrollbar {
      display: none;
    }
    .hide-scrollbar {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    /* Smooth transitions for hover effects */
    a, button {
      transition: all 0.2s ease;
    }

    /* Focus visible for accessibility */
    :focus-visible {
      outline: 2px solid #EC4899;
      outline-offset: 2px;
    }

    /* Selection color */
    ::selection {
      background: rgba(236, 72, 153, 0.2);
    }

    /* Prevent pull-to-refresh on mobile web */
    body {
      overscroll-behavior: none;
    }

    /* Gradient text helper (for web) */
    .gradient-text {
      background: linear-gradient(135deg, #EC4899 0%, #DB2777 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    /* Card hover animation */
    .card-hover:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    /* Button hover animation */
    .btn-hover:hover {
      transform: translateY(-2px);
    }

    /* Modal backdrop blur */
    .modal-backdrop {
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
    }

    /* ==================== MOBILE RESPONSIVE ==================== */

    /* Breakpoint utility classes */
    @media (max-width: 768px) {
      .hide-mobile {
        display: none !important;
      }
    }

    @media (min-width: 769px) {
      .show-mobile-only {
        display: none !important;
      }
    }

    /* Mobile Navigation - Sticky Header */
    @media (max-width: 768px) {
      .mobile-nav-sticky {
        position: sticky;
        top: 0;
        z-index: 1000;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
    }

    /* Mobile Drawer - Slide from Right */
    .mobile-drawer {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      width: 280px;
      max-width: 85vw;
      background: white;
      box-shadow: -4px 0 16px rgba(0, 0, 0, 0.15);
      transform: translateX(100%);
      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      z-index: 10001;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    .mobile-drawer-open {
      transform: translateX(0);
    }

    /* Mobile Drawer Overlay */
    .mobile-drawer-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10000;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
    }

    .mobile-drawer-overlay-visible {
      opacity: 1;
      pointer-events: auto;
    }

    /* Hamburger Icon Animation */
    .hamburger-icon {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 24px;
      height: 18px;
      cursor: pointer;
    }

    .hamburger-line {
      width: 100%;
      height: 2px;
      background: #1a1a1a;
      transition: all 0.3s ease;
      border-radius: 2px;
    }

    .hamburger-icon-open .hamburger-line:nth-child(1) {
      transform: translateY(8px) rotate(45deg);
    }

    .hamburger-icon-open .hamburger-line:nth-child(2) {
      opacity: 0;
    }

    .hamburger-icon-open .hamburger-line:nth-child(3) {
      transform: translateY(-8px) rotate(-45deg);
    }

    /* Prevent body scroll when drawer is open */
    body.drawer-open {
      overflow: hidden;
      position: fixed;
      width: 100%;
      height: 100%;
    }
  `));

  document.head.appendChild(style);
}
